import { REDUX_STATUS } from '@gymaholic/packages'

/**
 * Checks whether the given instance is saving.
 * @param   {Instance} instance
 * @returns {boolean}
 */
function isSavingReduxUtil (instance) {
  return !!(instance && instance.status === REDUX_STATUS.SAVING)
}

export default isSavingReduxUtil
